import { HttpStatus } from '@montugroup/apis-styleguide';
import { getOrderReceiptSignedUrl } from '@montugroup/circuit-api-contracts';
import { useQuery } from '@tanstack/react-query';
import { TsRestResponseError } from '@ts-rest/core';

import { getTsCustomerPortalClient } from '@montugroup/circuit-shared/api/customer-portal.client';

const client = getTsCustomerPortalClient();

export default function useGetOrderReceipt(orderCode: string, enabled: boolean) {
  const { data, isError, isLoading, refetch, error } = useQuery({
    queryKey: ['orderReceipt', orderCode],
    queryFn: async () => {
      const res = await client.getOrderReceiptSignedUrl.query({ params: { orderCode } });
      if (res.status !== HttpStatus.OK) {
        throw new TsRestResponseError(getOrderReceiptSignedUrl, res);
      }
      return res.body.data;
    },
    retry: (_, error) => {
      if (error instanceof TsRestResponseError) {
        return false;
      }
      return true;
    },
    enabled,
  });

  return {
    data,
    error,
    isError,
    isLoading,
    refetch,
  };
}
